import { Button, Separator } from "@elit-hair/elit-ui";
import { isMatch, useMatches } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { TbArrowLeft, TbChevronRight } from "react-icons/tb";

import { router } from "@/router";

import { Link } from "./link";

export function Breadcrumbs() {
    const matches = useMatches();
    const { t } = useTranslation();

    const matchesWithCrumbs = matches.filter((match) => isMatch(match, "staticData.config.breadcrumb"));
    const activeMatch = matchesWithCrumbs[matchesWithCrumbs.length - 1];
    const shouldHideParentBreadcrumbs = activeMatch?.staticData.config?.hideParentBreadcrumbs ?? false;
    const breadcrumbsToRender = shouldHideParentBreadcrumbs ? [activeMatch] : matchesWithCrumbs;

    const navigateBack = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        router.history.back();
    };

    if (breadcrumbsToRender.length === 0) {
        return null;
    }

    return (
        <div className="flex min-w-0 items-center gap-2 text-sm text-muted-foreground">
            <Button
                variant="ghost"
                size="icon"
                onClick={navigateBack}
                aria-label={t("go_back")}
                disabled={!router.history.canGoBack()}
            >
                <TbArrowLeft />
            </Button>

            <Separator orientation="vertical" className="h-4 bg-primary/40" />

            {breadcrumbsToRender.map((match, i) => {
                const isActive = i === breadcrumbsToRender.length - 1;
                const breadcrumb = match.staticData.config?.breadcrumb;

                if (!breadcrumb) {
                    return null;
                }

                return (
                    <div key={`${match.pathname}-${i}`} className="inline-flex items-center">
                        {!isActive && breadcrumb?.to && (
                            <Link to={breadcrumb.to} asChild>
                                <Button variant="ghost">{t(breadcrumb.title)}</Button>
                            </Link>
                        )}
                        {isActive && (
                            <Button variant="ghost" disabled>
                                {t(breadcrumb.title)}
                            </Button>
                        )}

                        {i + 1 < breadcrumbsToRender.length && (
                            <TbChevronRight className="h-4 w-4 transition-transform duration-200" />
                        )}
                    </div>
                );
            })}
        </div>
    );
}
